import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import BidContent from './BidContent';
import { BiddingProvider } from 'src/models/bids/BidFull/providers';
import { useFeatureFlag, FeatureFlag } from 'src/helpers/featureFlag';
import { Alert } from 'src/common';
import { Navigate, useParams } from 'react-router-dom';
import { Paths } from '../paths';
import { useBidWorkspace } from 'src/models/bids/Bids/hooks';

export const BidPage: FC = () => {
  const { t } = useTranslation();
  const isBidFlowFeature = useFeatureFlag(FeatureFlag.BiddingWorkflow_Tasks);
  const { id: bidId } = useParams<{ id: string }>();
  const { didFail } = useBidWorkspace(bidId);

  if (didFail) return <Navigate to={Paths.HOME_PATH} />;

  return isBidFlowFeature ? (
    <BiddingProvider>
      <BidContent />
    </BiddingProvider>
  ) : (
    <Alert message={t('Common.ACL.noAccessFeature')} type={'info'} />
  );
};

export default BidPage;
